import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { VideoTile } from "./LiveOverlay";

export function usePortrait() {
  const get = () => window.innerHeight > window.innerWidth;
  const [p, setP] = useState(get);
  useEffect(() => {
    const f = () => setP(get());
    window.addEventListener("resize", f);
    window.addEventListener("orientationchange", f);
    return () => { window.removeEventListener("resize", f); window.removeEventListener("orientationchange", f); };
  }, []);
  return p;
}

// Upright phone: TikTok style (one person full screen, others float). Sideways: the chosen layout.
// Tap any floating tile to make it the main one; tap the main one to go back.
export function StageTiles({ stage, s, layout, portrait, main, setMain, tileMark, zoom }) {
  const box = useRef(null);
  const dragged = useRef(false);
  const sorted = [...stage].sort((a, b) => Number(b.host) - Number(a.host));
  const tile = (p, cls, onTap, extra = {}) => <VideoTile key={p.id} tid={p.id} stream={p.stream} name={p.name} host={p.host} muted={p.me} mirror={p.me && !s.sharing} off={p.me && !s.camOn} mark={tileMark} speak={zoom} className={cls} onTap={onTap} {...extra} />;
  const float = sorted.length > 1 && (portrait || main || layout === "pip");
  if (float) {
    const lead = sorted.find((p) => p.id === main) || sorted[0];
    const rest = sorted.filter((p) => p !== lead);
    return (
      <div ref={box} className="absolute inset-0" data-testid={portrait ? "live-layout-tiktok" : `live-layout-${main ? "focus" : "pip"}`}>
        {tile(lead, "absolute inset-0 w-full h-full !rounded-none", main ? () => setMain(null) : null, { big: true, raised: true })}
        <motion.div drag dragConstraints={box} dragMomentum={false} onDragStart={() => { dragged.current = true; }} onDragEnd={() => setTimeout(() => { dragged.current = false; }, 50)}
          className={`absolute z-10 flex flex-col gap-2 cursor-grab active:cursor-grabbing ${portrait ? "left-3 top-28 w-[30%] max-w-[150px]" : "left-3 bottom-28 w-[22%] max-w-[260px]"}`} data-testid="live-float-stack">
          {rest.map((p) => tile(p, `w-full ${portrait ? "aspect-[3/4]" : "aspect-video"} ring-2 ring-white/30 shadow-2xl cursor-pointer`, () => !dragged.current && setMain(p.id)))}
        </motion.div>
      </div>
    );
  }
  const n = sorted.length;
  const cols = n <= 1 ? "grid-cols-1" : n <= 4 ? "grid-cols-2" : "grid-cols-3";
  const wrap = layout === "grid" || n <= 1 ? `absolute inset-0 grid ${cols} gap-1 p-1` : layout === "side" ? "absolute inset-0 flex gap-1 p-1" : "absolute inset-0 grid grid-cols-[3fr_1fr] grid-rows-[repeat(auto-fit,minmax(0,1fr))] gap-1 p-1";
  const cls = (i) => (layout === "side" && n > 1 ? "flex-1 h-full min-w-0" : layout === "spotlight" && n > 1 ? (i === 0 ? "w-full h-full row-span-full" : "w-full h-full") : "w-full h-full");
  return (
    <div className={wrap} data-testid={`live-layout-${layout}`}>
      {sorted.map((p, i) => tile(p, `${cls(i)} ${n > 1 ? "cursor-pointer" : ""}`, n > 1 ? () => setMain(p.id) : null, { big: true, raised: layout === "grid" && i >= n - (n <= 1 ? 1 : n <= 4 ? 2 : 3) }))}
      {!n && <div className="flex items-center justify-center text-white/50 text-sm" data-testid="live-waiting">Waiting for the host to come on camera…</div>}
    </div>
  );
}
